import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_KET_EXAMS_PLAN_REQUEST = 'FETCH_KET_EXAMS_PLAN_REQUEST';
export const FETCH_KET_EXAMS_PLAN_SUCCESS = 'FETCH_KET_EXAMS_PLAN_SUCCESS';
export const FETCH_KET_EXAMS_PLAN_FAILURE = 'FETCH_KET_EXAMS_PLAN_FAILURE';
export const FETCH_KET_EXAM_REQUEST = 'FETCH_KET_EXAM_REQUEST';
export const FETCH_KET_EXAM_SUCCESS = 'FETCH_KET_EXAM_SUCCESS';
export const FETCH_KET_EXAM_FAILURE = 'FETCH_KET_EXAM_FAILURE';
export const SUBMIT_KET_EXAM_RESULT_REQUEST = 'SUBMIT_KET_EXAM_RESULT_REQUEST';
export const SUBMIT_KET_EXAM_RESULT_SUCCESS = 'SUBMIT_KET_EXAM_RESULT_SUCCESS';
export const SUBMIT_KET_EXAM_RESULT_FAILURE = 'SUBMIT_KET_EXAM_RESULT_FAILURE';

const buildKetExamsPlanUrl = (groupId) => buildUrl(`/groups/${groupId}/ket-exams`);

export function fetchKetExamsPlanIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state,
        { method: 'GET', url: buildKetExamsPlanUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchKetExamsPlan(groupId));
  };
}

export function fetchKetExamsPlan(groupId) {
  return (dispatch) => {
    const url = buildKetExamsPlanUrl(groupId);
    const method = 'GET';

    return dispatch(fetchKetExamsPlanRequest()).payload
      .then((response) => dispatch(fetchKetExamsPlanSuccess(response)))
      .catch((error) => dispatch(fetchKetExamsPlanFailure(error)));

    function fetchKetExamsPlanRequest() {
      return ApiCall.createAction({
        type: FETCH_KET_EXAMS_PLAN_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchKetExamsPlanSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_KET_EXAMS_PLAN_SUCCESS,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchKetExamsPlanFailure(error) {
      return ApiCall.createAction({
        type: FETCH_KET_EXAMS_PLAN_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}

export function fetchKetExam(groupId, ketExamId) {
  return (dispatch) => {
    const url = buildUrl(`/ket-exams/${ketExamId}/content`);
    const method = 'GET';

    return dispatch(fetchKetExamRequest()).payload
      .then((response) => dispatch(fetchKetExamSuccess(response)))
      .catch((error) => dispatch(fetchKetExamFailure(error)));

    function fetchKetExamRequest() {
      const content = fetch(url);
      const results = fetch(buildUrl(`/ket-exams/${ketExamId}/results`));
      const payload = Promise.all([content, results])
        .then(([contentResp, resultsResp]) => ({
          ...contentResp,
          ...resultsResp,
        }));
      return ApiCall.createAction({
        type: FETCH_KET_EXAM_REQUEST,
        payload,
        url,
        method,
        groupId,
        ketExamId,
      });
    }

    function fetchKetExamSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_KET_EXAM_SUCCESS,
        payload,
        url,
        method,
        groupId,
        ketExamId,
      });
    }

    function fetchKetExamFailure(error) {
      return ApiCall.createAction({
        type: FETCH_KET_EXAM_FAILURE,
        error,
        url,
        method,
        groupId,
        ketExamId,
      });
    }
  };
}

export function submitKetExamResult(groupId, ketExamId, studentId, skillMarks) {
  return (dispatch) => {
    const url = buildUrl(`/ket-exams/${ketExamId}/students/${studentId}/results`);
    const method = 'PUT';

    return dispatch(submitKetExamResultRequest()).payload
      .then((response) => dispatch(submitKetExamResultSuccess(response)))
      .catch((error) => {
        dispatch(submitKetExamResultFailure(error));
        throw error;
      })
      .then(() => dispatch(fetchKetExam(groupId, ketExamId)));

    function submitKetExamResultRequest() {
      const request = fetch(url, {
        method,
        body: JSON.stringify({ skillMarks }),
      });
      return ApiCall.createAction({
        type: SUBMIT_KET_EXAM_RESULT_REQUEST,
        payload: request,
        url,
        method,
        groupId,
        ketExamId,
        studentId,
      });
    }

    function submitKetExamResultSuccess(payload) {
      return ApiCall.createAction({
        type: SUBMIT_KET_EXAM_RESULT_SUCCESS,
        payload,
        url,
        method,
        groupId,
        ketExamId,
        studentId,
      });
    }

    function submitKetExamResultFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_KET_EXAM_RESULT_FAILURE,
        error,
        url,
        method,
        groupId,
        ketExamId,
        studentId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/KetExams/actions.js